import { url } from '../../Server/url/GlobalUrl';
// import axios from "axios";


const PostShiftApi = async (data) => {
    console.log(data);
    let auth = localStorage.getItem("token")
    await fetch(url + "/jobs/user-shifts/", {
        method:"POST",
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json",
            'Authorization': 'Bearer ' + auth,

            
        },
        body: JSON.stringify(data)
    })
        .then((response) => {
            console.log("Response", response.json())
            if(response['status'] === 201 || response['status'] === 200){
                return response.json()
            }
        })
            .catch((err) => {
                console.log("ERROR",err.body);
            })
}

const PostJobApi = async (data, loginThis) => {
    console.log("DATA");
    console.log(loginThis.state.shift_data);
    let auth = localStorage.getItem("token")
	console.log('data1', data)
    	await fetch(url + '/jobs/job-post/', {
		method: 'POST',
		headers: {
		   'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + auth,
         

		},
		body: JSON.stringify(data)
	})
		.then((response) => {
            console.log("response", response)
            if (response['status'] === 201 || response['status'] === 200) {
                return response.json()
            } else if (response['status'] === 500 ) {
                    console.log(response.json());
                    loginThis.showCustomModal()
				    loginThis.setState({authResponse:'Job with this Patient Name and Address Already Exists'})
				    loginThis.setState({ custom_model: false})
            } else if (response['status'] === 401) {
                    loginThis.showCustomModal()
				    loginThis.setState({authResponse:'Session Expire'})
                    localStorage.removeItem('token')
            }
            else if(response['status'] === 400){
                 loginThis.showCustomModal()
                loginThis.setState({authResponse:'All fields are mandatory please Fill all the fields'})
                loginThis.setState({ custom_model: false});

            }
        })
		.then((result) => {
		console.log('access', result)
		if (result){
		    var i;
            for (i = 0; i < loginThis.state.shift_data.length; i++) {
                let auth = localStorage.getItem("token")
                var item = {'job' : result.id,'start_carer_type' : loginThis.state.shift_data[i]['start_carer_type'],'shift_type':loginThis.state.shift_data[i]['shift_type'],'end_carer_type':loginThis.state.shift_data[i]['end_carer_type'],  'start_repeate' : loginThis.state.shift_data[i]['start_repeate'],'start_date' : loginThis.state.shift_data[i]['start_date'],'end_date' : loginThis.state.shift_data[i]['end_date'],'start_date_arrival_time' : loginThis.state.shift_data[i]['start_date_arrival_time'], "shift_availablity":loginThis.state.shift_data[i]['shift_availablity'],'start_date_departure_time' : loginThis.state.shift_data[i]['start_date_departure_time'] , 'weekdays':loginThis.state.shift_data[i]['weekdays'],  'start_quantity' : loginThis.state.shift_data[i]['start_quantity'] }
              console.log('item',item)
              	fetch(url + '/jobs/user-shifts/', {
                    method: 'POST',
                    headers: {
                       'Accept': 'application/json',
                      'Content-Type': 'application/json',
                         'Authorization': 'Bearer ' + auth,

                    },
                    body: JSON.stringify(item)
                })
                    .then((response) => {
                        console.log("response", response)
                        if (response['status'] === 201 || response['status'] === 200) {
                            return response.json()
                        } else if (response['status'] === 400 ) {
                                console.log('giving 400')
                                return response.json()
                        } else if (response['status'] === 401) {
                                console.log('giving 401')
                                return response.json()
                        }
                    })
                    .then((result) => {
                        console.log('Hello',result)
                     })
            }
			loginThis.showSuccessModal()
            loginThis.setState({ modal_id: '/job-details/'+result.id+'/'})
            loginThis.setState({ custom_model: true})

            }
		});
		console.log('data2', data)

}

export { PostJobApi ,PostShiftApi};

